import React from 'react';
import styled from 'styled-components';
const LoadingOverlay = styled.div.withConfig({
  displayName: "LoadingWrapper__LoadingOverlay",
  componentId: "sc-1w43tjb-0"
})(["position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;background-color:rgba(255,255,255,0.6);border-radius:4px;"]);
const LoadingWrapper = ({
  isLoading,
  children
}) => React.createElement(React.Fragment, null, isLoading && React.createElement(LoadingOverlay, null), children);
export default LoadingWrapper;